import { Injectable, inject } from '@angular/core';

import { TODO } from '@b2b/types/core/utils';

import { CalendarService } from '../calendar/calendar.service';
import { HelpersService } from '../helpers/helpers.service';

/**
 * ResourcesService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/resources/resources.service.js.
 * Formats resource requests/time-frames for the templates, programs and audit
 * trail views. Pure transformation logic with a single piece of state
 * (`schedule`) set via `setSchedule`.
 *
 * Registered back into AngularJS under 'ResourcesService' via
 * downgradeInjectable in app/upgrade/ng-downgraded-components.ts.
 */
@Injectable({ providedIn: 'root' })
export class ResourcesService {
  private helpers = inject(HelpersService);
  private calendar = inject(CalendarService);

  schedule: TODO = {};

  init(): boolean {
    return true;
  }

  prepareRequest(request: TODO): TODO {
    const r = request;

    r.resourceTimeFrame.end.timeFrame = r.resourceTimeFrame.end.timeFrame.type;
    r.resourceTimeFrame.end.allocation = r.resourceTimeFrame.end.allocation.type;
    r.resourceTimeFrame.end.type = r.resourceTimeFrame.end.type.type;

    r.resourceTimeFrame.start.timeFrame = r.resourceTimeFrame.start.timeFrame.type;
    r.resourceTimeFrame.start.allocation = r.resourceTimeFrame.start.allocation.type;
    r.resourceTimeFrame.start.type = r.resourceTimeFrame.start.type.type;

    return r;
  }

  setSchedule(schedule: TODO): void {
    this.schedule = schedule;
  }

  processRequest(request: TODO): TODO {
    const r = request;

    if (request.resourceTimeFrame) {
      r.startTime = this.processRequestTime(request.resourceTimeFrame.start);
      r.endTime = this.processRequestTime(request.resourceTimeFrame.end);
    }

    if (request.eventResource) {
      r.category = this.helpers.cap(
        this.helpers.getEntityName(request.eventResource.resourceCategory).displaySingular as string,
      );
      r.quantity = request.eventResource.quantity;
      r.resourceTemplate = request.eventResource.type;
      r.resource = request.eventResource.resourceName || '';
      if (request.eventResource.values instanceof Array) {
        r.attributes = request.eventResource.values.join(', ');
      } else if (typeof request.eventResource.values === 'string') {
        r.attributes = request.eventResource.values;
      }
    }

    return r;
  }

  processRequestTime(time: TODO): string {
    const r: string[] = [];

    // 1 hour 30 mins
    if (time.timeFrame !== 'when') {
      r.push(this.calendar.durationToString(time.duration));
    }

    // before
    r.push(time.timeFrame);

    if (time.timeFrame !== 'duration') {
      // every instance
      if (this.schedule.repeatCycle === 'never') {
        r.push('the event');
      } else {
        r.push(time.allocation.toLowerCase() + ' instance');
      }
      // starts
      r.push(time.type.toLowerCase());
    }

    return this.helpers.cap(r.join(' '));
  }

  processRequests(requests: TODO[]): TODO[] {
    const r: TODO[] = [];
    for (let i = 0, ii = requests.length; i < ii; i++) {
      r.push(this.processRequest(requests[i]));
    }
    return r;
  }
}
